const NS = 'DatePickerDialogCtrl';

export default function DatePickerDialogCtrl(
  $scope, date, onCancel, onSave, displayMode
) {
  "ngInject";

  $scope.date = date;
  $scope.onCancel = onCancel;
  $scope.onSave = onSave;
  $scope.displayMode = displayMode;
}
